import { UserRole } from "@green0meter/api-client";
import React, { FC } from "react";

import { useUserStore } from "@store/user";
import { NotAuthorized } from "@components/common";

type RequireRole = {
  children: React.ReactNode;
  roles: UserRole[];
};

const RequireRole: FC<RequireRole> = ({ children, roles }) => {
  const { user } = useUserStore();

  const hasAccess =
    user && [UserRole.Admin, ...roles].includes(user.role);

  if (!hasAccess) {
    return <NotAuthorized />;
  }

  return <>{children}</>;
};

export default RequireRole;
